import { createI18n } from 'vue-i18n'
import zhCN from '/@/locales/zh-CN'
import enUS from '/@/locales/en-US'
import { EStorageKey } from '/@/types'

export const SUPPORT_LOCALES = ['zh-CN', 'en-US'] as const
export type AppLocale = (typeof SUPPORT_LOCALES)[number]

export function isAppLocale (value: string | null | undefined): value is AppLocale {
  return value === 'zh-CN' || value === 'en-US'
}

function readStoredLocale (): AppLocale {
  const saved = localStorage.getItem(EStorageKey.LANG_CODE)
  return isAppLocale(saved) ? saved : 'zh-CN'
}

/**
 * 渐进式国际化：仅已接入 $t / useI18n 的页面会切换语言，其余页面仍为硬编码中文。
 * 新模块：在 locales/zh-CN、en-US 下新增文件并在 index 中合并。
 */
export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: readStoredLocale(),
  fallbackLocale: 'zh-CN',
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS,
  },
})

export default i18n
